import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "sonner";
import Layout from "@/components/Layout";
import { ApkProvider } from "@/hooks/useLatestApk";
import Home from "@/pages/Home";
import Download from "@/pages/Download";
import LatestVersion from "@/pages/LatestVersion";
import Changelog from "@/pages/Changelog";
import About from "@/pages/About";
import Support from "@/pages/Support";
import Contact from "@/pages/Contact";
import Privacy from "@/pages/Privacy";
import Terms from "@/pages/Terms";
import NotFound from "@/pages/NotFound";
import AdminLogin from "@/pages/AdminLogin";
import AdminDashboard from "@/pages/AdminDashboard";

function App() {
  return (
    <div className="App grain">
      <Toaster theme="dark" position="top-center" richColors />
      <ApkProvider>
        <BrowserRouter>
          <Routes>
            <Route path="/admin/login" element={<AdminLogin />} />
            <Route path="/admin" element={<AdminDashboard />} />
            <Route element={<Layout />}>
              {["", "/hi"].map((pre) => (
                <Route key={pre || "en"} path={pre || "/"}>
                  <Route index element={<Home />} />
                  <Route path="download" element={<Download />} />
                  <Route path="latest-version" element={<LatestVersion />} />
                  <Route path="changelog" element={<Changelog />} />
                  <Route path="about" element={<About />} />
                  <Route path="support" element={<Support />} />
                  <Route path="contact" element={<Contact />} />
                  <Route path="privacy-policy" element={<Privacy />} />
                  <Route path="terms" element={<Terms />} />
                  <Route path="*" element={<NotFound />} />
                </Route>
              ))}
            </Route>
          </Routes>
        </BrowserRouter>
      </ApkProvider>
    </div>
  );
}

export default App;
